var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86617 9.09849L13.0642 10.1555C13.4582 10.2345 13.7652 10.5415 13.8452 10.9355L14.9012 16.1335L18.4192 5.58049L7.86617 9.09849ZM14.6672 20.9995C14.6462 20.9995 14.6262 20.9985 14.6062 20.9975C14.1542 20.9705 13.7772 20.6425 13.6862 20.1995L12.0172 11.9825L3.80117 10.3125C3.35717 10.2225 3.02917 9.84549 3.00217 9.39349C2.97417 8.94149 3.25417 8.52749 3.68317 8.38449L19.6832 3.05149C20.0432 2.92949 20.4392 3.02449 20.7072 3.29249C20.9752 3.56049 21.0682 3.95649 20.9492 4.31649L15.6152 20.3165C15.4782 20.7265 15.0952 20.9995 14.6672 20.9995Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 19,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86617 9.09849L13.0642 10.1555C13.4582 10.2345 13.7652 10.5415 13.8452 10.9355L14.9012 16.1335L18.4192 5.58049L7.86617 9.09849ZM14.6672 20.9995C14.6462 20.9995 14.6262 20.9985 14.6062 20.9975C14.1542 20.9705 13.7772 20.6425 13.6862 20.1995L12.0172 11.9825L3.80117 10.3125C3.35717 10.2225 3.02917 9.84549 3.00217 9.39349C2.97417 8.94149 3.25417 8.52749 3.68317 8.38449L19.6832 3.05149C20.0432 2.92949 20.4392 3.02449 20.7072 3.29249C20.9752 3.56049 21.0682 3.95649 20.9492 4.31649L15.6152 20.3165C15.4782 20.7265 15.0952 20.9995 14.6672 20.9995Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.04dfd31d.svg";
export { ForwardRef as ReactComponent };